
export const filteredFilter = (filter) => {
    return Object.fromEntries(
        Object.entries(filter ?? {}).filter(([k, v]) => v)
    )
}